import { localRepository } from './repository';

let scheduled: Promise<void> | null = null;
let rerunRequested = false;

/**
 * Coalesce import-triggered rebuilds. A stale snapshot is retried because a
 * concurrent import or another tab committed a newer processing generation.
 * Import persistence is already complete before this workflow starts.
 */
export function scheduleLocalMarketProcessing(): void {
  rerunRequested = true;
  if (scheduled !== null) return;

  scheduled = (async () => {
    while (rerunRequested) {
      rerunRequested = false;
      try {
        const result = await localRepository.processPending();
        if (result.disposition === 'stale-snapshot') rerunRequested = true;
      } catch (error) {
        // The durable queue remains intact. A later import or app startup may retry.
        console.error('Could not rebuild local market views.', error);
      }
    }
  })().finally(() => {
    scheduled = null;
    if (rerunRequested) scheduleLocalMarketProcessing();
  });
}
